import includes from 'lodash/includes';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuidV4 from 'uuid/v4';
import Checkbox from '@spothero/ui/checkbox';
import Label from '@spothero/ui/label';
import Icon from 'common/icon/Icon';

export default class AmenityFilterItem extends Component {
    static propTypes = {
        amenity: PropTypes.object.isRequired,
        activeAmenities: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        const {
            amenity: {
                slug
            },
            activeAmenities
        } = props;

        this._inverseSlug = `no-${slug}`;

        this.state = {
            isDenyChecked: includes(activeAmenities, this._inverseSlug),
            confirmKey: uuidV4()
        };
    }

    _onAmenityConfirm = evt => {
        const {
            amenity: {
                slug
            },
            onChange
        } = this.props;

        onChange(slug, evt.target.checked);
    }

    _onAmenityDeny = evt => {
        const isDenyChecked = evt.target.checked;

        this.setState({
            isDenyChecked,
            confirmKey: uuidV4()
        });

        this.props.onChange(this._inverseSlug, isDenyChecked);
    }

    _renderLabel() {
        const {
            amenity: {
                slug,
                name,
                count
            }
        } = this.props;

        return (
            <Label className="AmenityFilterItem-label">
                <Icon
                    className="AmenityFilterItem-label-icon"
                    name={`amenity-${slug}`}
                />
                <span className="AmenityFilterItem-label-text"> {name}</span>
                <span className="AmenityFilterItem-label-count"> ({count})</span>
            </Label>
        );
    }

    render() {
        const {
            amenity,
            activeAmenities
        } = this.props;
        const {
            isDenyChecked,
            confirmKey
        } = this.state;
        const amenityDisabled = amenity.count === 0 && !includes(activeAmenities, this._inverseSlug);
        const classes = classNames(
            'AmenityFilterItem',
            {'AmenityFilterItem-disabled': amenityDisabled}
        );

        return (
            <div
                className={classes}
            >
                <div className="AmenityFilterItem-checkboxes">
                    <Checkbox
                        key={confirmKey}
                        id={`AmenityFilterItem-${amenity.slug}-confirm`}
                        className="AmenityFilterItem-checkbox"
                        name={amenity.slug}
                        defaultChecked={includes(activeAmenities, amenity.slug)}
                        label={<Label className="AmenityFilterItem-checkbox-label"><span>Confirm</span></Label>}
                        disabled={amenityDisabled || isDenyChecked}
                        onChange={this._onAmenityConfirm}
                    />
                    <Checkbox
                        id={`AmenityFilterItem-${this._inverseSlug}-deny`}
                        className="AmenityFilterItem-checkbox AmenityFilterItem-checkbox-deny"
                        name={this._inverseSlug}
                        iconName="times"
                        defaultChecked={isDenyChecked}
                        label={<Label className="AmenityFilterItem-checkbox-label"><span>Deny</span></Label>}
                        onChange={this._onAmenityDeny}
                    />
                </div>
                {this._renderLabel()}
            </div>
        );
    }
}
